module.exports = __webpack_public_path__ + "img/gpo.061eccae.png";